<template>
  <!-- postech create form -->
  <div class="container">
    <!--div class="debug">
            <p>props.projectId = {{ props.projectId }}</p>
            <p>props.postechId = {{ props.postechId }}</p>
        </div>-->

    <MyForm :title="'Postech Form'">
      <template v-slot:fields>
        <!--FormInput v-model="postech.id" :readonly="true" :disabled="true" :name="'postech id:'"></FormInput-->
    <!--    <FormInput
          v-model="postech.projectId"
          :readonly="true"
          :disabled="true"
          :name="'project id:'"
        ></FormInput> -->
        <FormInput v-model="postech.pilesSupporting" :name="'piles supporting:'"></FormInput>
        <!--FormInput v-model="postech.installer" :name="'installer:'"></FormInput-->
        <Suspense>
          <template #default>
            <!--CustomerSelect
              :displayName="'Installer'"
              v-model:selected="postech.installer.id"
            ></CustomerSelect>-->
             <CustomerListbox v-model:customer="postech.installer"></CustomerListbox>
          </template>
          <template #fallback> loading installer... </template>
        </Suspense>

        <!-- radios for load provided/designed -->
        <RadioGroup :options="radioOptions" v-model:selected="postech.pileLoads"></RadioGroup>

        <!-- pile table -->
        <Suspense>
          <template #default>
            <Postech-piles-table v-model:piles="postech.piles"></Postech-piles-table>
          </template>
          <template #fallback> assigning piles.... </template>
        </Suspense>
        <!--
                <MyTable id="postechTable" :header="pilesHeader" :data="postech.piles" :columns="pilesHeader"
                @rowClicked="pileGroupClicked"></MyTable>
            -->
      </template>

      <template v-slot:buttons>
        <div class="form-btns">
          <FormBtn :name="'Submit'" @clicked="submitForm"></FormBtn>
          <FormBtn :name="'Revert'" @clicked="revertForm"></FormBtn>
        </div>
      </template>
    </MyForm>
  </div>
  <!-- end of postech view -->
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { loadingStart, loadingEnd } from '@/js/common.js'
import { MyForm, FormInput, FormBtn, RadioGroup } from '@/components/form'
import PostechPilesTable from './Postech-piles-table.vue'
import CustomerListbox from '@/components/Customer-listbox.vue';
import { usePostechStore } from '@/stores/'
import router from '@/router'
import { useCurrentProject } from '@/composables/Current-project';
import type { Postech, Customer, PostechPile, PileType } from '@/types/types'
//import { storeToRefs } from 'pinia';

const postechStore = usePostechStore()
//const pileStore = usePileStore();

const props = defineProps<{
  //index: number,
  projectId: number
  //postechId : number,
  //pileOptions: Array<PileType>,
  //installerOptions: Array<Customer>
}>()

//const projects = useProjectStore()
//const { currentProject } = await storeToRefs(projects)
const { currentProject } = useCurrentProject();
//const installer = await projects.currentProject.customer;
//TODO maybe pass installerId as param in router push?
//const postechArr = await postechStore.getProjectPostechs(props.projectId);
//const installer = postechArr[0].installer; //NO get the customer for the project

const emptyPostech: Postech = {
  postechId: -1,
  created_by: 'chris@smpwork.com',
  projectId: props.projectId,
  pilesSupporting: '',
  pileLoads: 'Loads Calculated',
  piles: [{ pileType: null, pileCount: null, torqueMin: null, torqueMax: null }],
  installer: currentProject.value.customer
}

const postech = ref<Postech>(emptyPostech)
//postech.value = await postechStore.getById(props.postechId);

const radioOptions = ['Loads Calculated', 'Loads Provided by Others']
//const mPileGroup = ref<PostechPile>({});    //pile group fields on modal form
//const mShow = ref(false);
//const mId = ref(`pile-group-modal`);

//const { allPiles } = storeToRefs(pileStore);
//const pileOptions = ref<Array<PileType>>([]) //projects.fetchPileOptions);
//await fetchPileOptions()
// TODO This is a hack to just take the first postech object
/*
const reactiveCopy = computed(() => {
    return model.value[0];
});
*/
/*
async function fetchPileOptions() {
  console.log('Postech-form.fetchPileOptions()...')
  pileOptions.value = await postechStore.getAllPileTypes()
}*/

/**
 * Submit postech form via pinia store
 */
async function submitForm() {
  console.log('Postech-form.submitForm()..')
  await postechStore.createPostech(postech.value)
  
}

/**
 * TODO this works on a single postech object, search that up from Contrller
 */
async function revertForm() {
  console.log('Postech-create-form.cancelled()...')
  router.push({
    name: 'project_postechs',
    params: {
      projectId: props.projectId.toString()
      //postechId: createdId
    }
  })
  //router.push(`/projects/${props.projectId}/invoices`);
  // await fetchPostech();
  //postech.value = await postechStore.getById(props.postechId);
}


const writeableFields = [
  { id: 'mPileId', name: 'Pile Group Id', comp: 'pileId', disabled: true },
  { id: 'mPileType', name: 'Pile Type', comp: 'pileType' },
  { id: 'mTorqueMin', name: 'Min Torque', comp: 'torqueMin' },
  { id: 'mTorqueMax', name: 'Max Torque', comp: 'torqueMax' },
  { id: 'mPileCount', name: 'Pile Count', comp: 'pileCount' }
]

//TODO emit this to accordion parent and have one modal instance for the group
function pileGroupClicked(item: PostechPile) {
  console.log('pileGroupClicked...doing nothing')
  console.log('item = ' + JSON.stringify(item))
  //bind item to mPileGroup
  // state.modal_editing = true;
  //mPileGroup.value = item;
  //mPileGroup.value = Object.assign(item, {});
  //openModal();
}
/*
function openModal() {
    console.log("openModal...");
    mShow.value = true;
    //state.modal_demo.show();
}

function closeModal() {
    console.log("closeModal...");
    mPileGroup.value = {};
    state.modal_demo.hide()
    state.modal_editing = false;
}*/

/**
 * This should write the modal's pile group changes to the
 * current Postech model in the view, not update the Database
 * TODO need a copy mechanism for the current working postech object
 */
async function updatePileGroup() {
  loadingStart()
  console.log('updatePileGroup...')
  /*
    const updated = await DbAdapter.updatePileGroup(mPileGroup.value);
    if (updated) {
        postech.value.piles[mIndex] = updated;   //TODO error handling
    }
    */
  loadingEnd()
  //closeModal();
}

/**
 * index of current pileGroup (in table array) being displayed in modal
 *
const mIndex = computed(() => {
    console.log('computing mIndex...');
    let index = -1;

    try {
        index = postech.value.piles.findIndex((value, index, array) => {
            console.log("index, value = " + index + ": " + JSON.stringify(value));
            return value.pileId == mPileGroup.value.pileId;
        });
    } catch (error) {
        console.log("mIndex not found");
    }
    return index;
});*/

/*
function toastShow(message) {
    console.log("Project-postech.vue toastShow()...");
    toastMessage.value = message;
    //Toast.show();
    //Toaster.value = null;
    toasterKey.value += 1;
    //Toast.value = Toast;
}*/

/**
 * TODO this should not update the cache, just add to the postech object
 * no pileId is assigned, backend controls this assignment
 * @param {Array} pileGroup The array of JSON for new piles entry
 */
async function addPileGroup(pileGroup) {
  console.log('addPileGroup...')
  loadingStart()
  pileGroup.projectId = props.projectId
  pileGroup.postechId = postech.value.id
  await postech.value.piles.push(pileGroup)
  loadingEnd()
  //closeModal();
  //toastShow('PileGroup added : ' + JSON.stringify(success));
}

/**
 * TODO this should just remove the pilegroup arr from the postech object
 * no updating of cache or database
 */
async function deletePileGroup() {
  loadingStart()
  console.log('deletePileGroup...')
  console.log('mPileGroup.pileId = ' + mPileGroup.value.pileId)
  //copy/store mIndex as it is reactive:
  const delIndex = mIndex.value
  console.log('delIndex = ' + delIndex)
  if (delIndex > -1) {
    // only splice array when item is found
    console.log('found a match at index = ' + delIndex)
    postech.value.piles = postech.value.piles.toSpliced(delIndex, 1) // 2nd parameter means remove one item only
  }
  loadingEnd()
  //closeModal();
  //toastShow('PileGroup deleted : ' + JSON.stringify(deleted));
}
</script>
